




















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Client } from "@/rest/client";
import { Rules } from "@/assets/rules";
import AppSnackbar from "@/components/AppSnackbar.vue";
import { Refs } from "@/assets/ref";
import axios, { AxiosRequestConfig } from "axios";

@Component({
  components: {
    AppSnackbar,
  },
})
export default class ContactUs extends Vue {
  valid = true;
  lazy = false;
  firstName = "";
  lastName = "";
  companyName = "";
  clientMail = "";
  mailBody = "";
  // rules
  rules = {
    required: Rules.required,
    alphabeticOnly: Rules.alphabeticOnly,
    max60: Rules.max60,
    max100: Rules.max100,
    max255: Rules.max255,
    email: Rules.email,
  };
  // References
  $refs!: Refs<{
    snackbar: AppSnackbar;
  }>;

  /**
   * Submit form for Netlify
   */
  async handleSubmit() {
    // if form is valid
    if (this.validateForm()) {
      let client = {
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        clientMail: this.clientMail,
        mailBody: this.mailBody,
      };
      let clientRequest = new Client(client);

      const axiosConfig: AxiosRequestConfig = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      };
      axios
        .post(
          "/",
          this.encode({
            "form-name": "contact-us-form",
            ...clientRequest,
          }),
          axiosConfig
        )
        .then(() => {
          this.$router.push("success");
        })
        .catch(() => {
          this.$router.push("fail");
        });
      this.cleanForm();
    }
  }
  encode(data: any) {
    return Object.keys(data)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      )
      .join("&");
  }

  validateForm() {
    let formIsNotValid = !(this.$refs.form as Vue & {
      validate: () => boolean;
    }).validate();
    if (formIsNotValid) {
      return false;
    } else {
      return true;
    }
  }

  cleanForm() {
    (this.$refs.form as Vue & {
      reset: () => boolean;
    }).reset();
    this.firstName = "";
    this.lastName = "";
    this.companyName = "";
    this.clientMail = "";
    this.mailBody = "";
  }
}
